import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { z } from "zod";

export const createPromoBannerSchema = (locale: Locales) => {
  const promoBannerSchema = z.object({
    email: z
      .string({
        required_error: __("Email is required", locale),
      })
      .trim()
      .email({ message: __("Invalid email", locale) }),
  });

  return { promoBannerSchema };
};

export type PromoBannerSchema = z.infer<ReturnType<typeof createPromoBannerSchema>["promoBannerSchema"]>;
